export const validateReference = (reference?: string) => {
  return reference?.trim().length ? undefined : 'Please enter a reference.'
}
